import { render, staticRenderFns } from "./ProductList1.vue?vue&type=template&id=5d6b6cbc&"
import script from "./ProductList1.vue?vue&type=script&lang=js&"
export * from "./ProductList1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports